/**
 * Single source of truth for community branding, coordinates, and Firebase hints.
 * Import from siteConfig.js (or directly) in web code. Reference when provisioning a new HOA customer.
 */

/** Override hero background at build time: REACT_APP_BACKGROUND_IMAGE=/path/or/url.jpg */
export const HERO_IMAGE = {
  defaultAsset: 'src/assets/nmr_main.jpg',
  envVar: 'REACT_APP_BACKGROUND_IMAGE',
  /** Optimized hero JPEG (~270 KB at 1920px width). Re-run ffmpeg if replacing the source photo. */
  compressBeforeDeploy: false,
};

export const CONTACT = {
  contactEmail: 'mikeechafin@gmail.com',
  salesEmail: 'sales@nantahalamountainresort.org',
};

/** County tax assessor GIS used for owner parcel / property-line links */
export const PARCEL_GIS = {
  county: 'Macon County',
  state: 'NC',
  mapViewerUrl: 'https://gis2.maconnc.org/lightmap/Maps/default.htm',
  parcelRecordUrl: 'https://gis2.maconnc.org/lightmap/SearchFind.aspx',
  parcelSearchUrl: 'https://gis2.maconnc.org/lightmap/searchfind.aspx',
  downloadsUrl: 'https://gis2.maconnc.org/lightmap/downloads.aspx',
};

/** Primary map / weather / flight-radar anchor for NMR */
export const COMMUNITY_COORDINATES = {
  latitude: 35.248242,
  longitude: -83.69559,
  elevation: 850,
  mapCenter: [35.25, -83.696],
};

export const FIREBASE_HINTS = {
  projectId: 'nantahala-mountain-resor-596d9',
  authDomain: 'nantahala-mountain-resor-596d9.firebaseapp.com',
  storageBucket: 'nantahala-mountain-resor-596d9.firebasestorage.app',
  messagingSenderId: '44364961786',
  appId: '1:44364961786:web:5c7b801600c54f32487643',
  firestoreDatabaseId: 'nmrdb',
  functionsRegion: 'us-central1',
  functionsBaseUrl: 'https://us-central1-nantahala-mountain-resor-596d9.cloudfunctions.net',
  hostingTargets: {
    main: { public: 'build', site: 'nantahala-mountain-resor-596d9' },
    demo: { public: 'build-demo', site: 'nantahala-demo' },
  },
  demoSiteUrl: 'https://nantahala-demo.web.app',
  productionSiteUrl: 'https://nantahalamountainresort.org',
};

export const SITE_MODES = {
  PRODUCTION: 'production',
  DEMO: 'demo',
  MARKETING: 'marketing',
};

export const BRANDING_BY_MODE = {
  production: {
    siteName: 'Nantahala Mountain Resort',
    shortName: 'NMR',
    communityName: 'Nantahala Mountain Resort',
    legalEntity: 'Nantahala Mountain Resort HOA',
    tagline: 'Owner community portal for the Nantahala mountains',
    contactEmail: CONTACT.contactEmail,
    salesEmail: CONTACT.salesEmail,
    websiteUrl: FIREBASE_HINTS.productionSiteUrl,
    demoSite: false,
    marketingSite: false,
    showDemoBanner: false,
  },
  demo: {
    siteName: 'Pine Ridge Estates',
    shortName: 'PRE',
    communityName: 'Pine Ridge Estates',
    legalEntity: 'Pine Ridge Estates HOA (Demonstration)',
    tagline: 'AI HOA management demo — self-manage without a management company',
    contactEmail: 'demo@hoa-community-portal.example',
    salesEmail: 'demo@hoa-community-portal.example',
    websiteUrl: FIREBASE_HINTS.demoSiteUrl,
    demoSite: true,
    marketingSite: false,
    showDemoBanner: true,
  },
  marketing: {
    siteName: 'HOA Community Portal',
    shortName: 'HOA Portal',
    communityName: 'HOA Community Portal',
    legalEntity: 'HOA Community Portal',
    tagline: 'AI-powered HOA management — skip the management company markup',
    contactEmail: 'sales@hoa-community-portal.example',
    salesEmail: 'sales@hoa-community-portal.example',
    websiteUrl: FIREBASE_HINTS.demoSiteUrl,
    demoSite: true,
    marketingSite: true,
    showDemoBanner: true,
  },
};

export const DEMO_USER = {
  uid: 'demo-owner-001',
  email: 'owner@pineridge.demo',
  displayName: 'Alex Morgan',
  isAdmin: false,
};

export const DEMO_ADMIN_USER = {
  uid: 'demo-admin-001',
  email: 'admin@pineridge.demo',
  displayName: 'Jordan Lee',
  isAdmin: true,
};